/* eslint-disable max-len */
//TODO:  validate input on color attribute    info,warning,danger,success --- should we name differently?  what about other colors   use ThemeColor1, ThemeColor2, etc?

import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PageObjectService } from '@Core/models/proprietary/page/page-object.service';
import { PageState, PageView } from '@Core/models/proprietary/page/page.state';
import { AppService } from '@Core/services/proprietary/app.service';
//import { fileVersion } from 'src/app/main';

@Component({
    standalone: false,
    selector: 'ep-sub-panel',
    template: `
    <div
      class="ep-sub-panel"
      title=""
      
      [class.uxDesignerHiddenSubsection]="designerMode && hidden"
    >
      <div
        [class.unity-card]="panelType == 'box'"
        [class.panel-box]="panelType == 'box'"
        [class.panel-transparent]="panelType == 'transparent'"
        [class.panel-divider]="panelType == 'divider' || panelType == 'minor-divider'"
        [class.panel-major-divider]="panelType == 'major-divider'"
        [class.panel-line-divider]="panelType == 'line-divider'"
        [class.panel-border-box]="panelType == 'box'"
        [class.sub-panel-block-1]="blockWidth == '1'"
        [class.sub-panel-block-2]="blockWidth == '2'"
        [class.sub-panel-block-3]="blockWidth == '3'"
        [class.sub-panel-block-4]="blockWidth == '4'"
      >
        <div
          width="100%"
          class="{{ panelType != 'box' ? 'unity-title unity-title-small' : 'unity-headline unity-headline-small' }}
          "
          [style.min-height]="minTitleHeight"
          [class.panel-title-box]="panelType == 'box'"
          [class.panel-title-transparent]="panelType == 'transparent'"
          [class.panel-title-divider]="panelType == 'divider' || panelType == 'minor-divider'"
          [class.panel-title-major-divider]="panelType == 'major-divider'"
          [class.panel-title-line-divider]="panelType == 'line-divider'"
        >
          <!-- <i *ngIf="icon" [class]="'fa fa-ep-list ' + icon" style="margin-right: 3px;"></i> -->
          <span
            [class.panel-title-text-box]="panelType == 'box'"
            [class.panel-title-text-transparent]="panelType == 'transparent'"
            [class.panel-title-text-divider]="panelType == 'divider' || panelType == 'minor-divider'"
            [class.panel-title-text-major-divider]="panelType == 'major-divider'"
            [class.panel-title-text-line-divider]="panelType == 'line-divider'"
            [style.margin-right]="title && title > '' ? '5px' : '0px'"
            >{{ title }}</span
          >
          <button unity-button
            *ngIf="hasFormValidationErrors() && showErrorIndicator"
            classes="icon-only icon-only-large"
            style="margin-right:8px; display: inline-flex;"
            ngbTooltip="Validation errors!  Click to highlight errors."
            (click)="highlightErrors()"
          >
            <svg class="unity-icon unity-icon-warning-fill" style="fill:red;">
              <use xlink:href="#unity-icon-warning-fill"></use>
            </svg>
          </button>
          <unity-badge
            *ngIf="!(badgeText == '' || badgeText == '0')"
            [class]="'muted ' + (badgeClass && badgeClass != '' ? badgeClass : getStatusClass(badgeText))"
          >
            {{ badgeText }}
          </unity-badge>
          <button unity-button
            *ngIf="designerMode && (currentPageView$ | async)?.Layout_Object_Code != 'CORE'"
            class="uxDesignerHideIcon pull-right"
            classes="icon-only icon-only-large"
            style="margin-left: 5px"
            [ngbTooltip]="hidden ? 'Show Section' : 'Hide Section'"
            (click)="toggleHidden()"
          >
            <svg [class]="'unity-icon ' + (hidden ? 'unity-icon-eye-slash' : 'unity-icon-eye')" style="fill: orange">
              <use attr.xlink:href="#{{ hidden ? 'unity-icon-eye-slash' : 'unity-icon-eye' }}"></use>
            </svg>
          </button>

          <ng-content select="ep-sub-panel-menu"></ng-content>
          <button unity-button
            *ngIf="allowClose"
            class="pull-right"
            classes="icon-only icon-only-large"
            type="button"
            (click)="close()"
          >
            <svg class="unity-icon unity-icon-times">
              <use xlink:href="#unity-icon-times"></use>
            </svg>
          </button>
        </div>

        <hr
          *ngIf="panelType == 'line-divider'"
          style="color: var(--unity-semantic-color-border-neutral-standard-alpha-default); padding:0px; margin-bottom:5px; margin-top:0px"
        />
        <ng-content *ngIf="!hidden"></ng-content>
      </div>
    </div>
  `,
    styles: [
        '.panel-box {border: 1px solid var(--unity-primitive-color-gray-025); border-radius: 8px; margin-bottom: 5px; padding: var(--unity-spacing-08) var(--unity-spacing-12)}',
        '.panel-transparent {margin-bottom: 5px; padding: 0px;}',
        '.panel-divider {margin-bottom: 5px; padding: 0px;}',
        '.panel-major-divider {margin-bottom: 5px; padding:0px;}',
        '.panel-line-divider {margin-bottom: 5px; padding:0px}',
        '.panel-border-box {}',
        '.panel-title-box {margin: 0px; min-height: 30px; display: block; padding: 10px 0;color: var(--unity-semantic-color-foreground-neutral-secondary);}',
        '.panel-title-transparent {margin: 0px; min-height: 28px; display: block; padding: 0px;}',
        '.panel-title-divider {margin: 0px; line-height: 19px; display: flex; align-items:center; padding:10px 0;}',
        '.panel-title-major-divider {margin: 0px; line-height: 19px; display: flex; align-items:center; padding:0px; }',
        '.panel-title-line-divider {margin: 0px; line-height: 19px; display: flex; align-items:center; padding:0px; }',
        '.panel-title-text-transparent { font-weight:700;}',
        '.panel-title-text-divider { font-weight:700;}',
        '.panel-title-text-major-divider { }',
        '.panel-title-text-line-divider { display: flex; padding: 10px 0}',
        '.panel-title-text-box {color: var(--unity-semantic-color-foreground-neutral-secondary); }'
    ]
})
export class SubPanelComponent {
    private _badgeText = '';
    public hidden = false;

    @Select(PageState.currentPageView)
    currentPageView$: Observable<PageView>;

    @Input()
    panelType = 'box'; //box, transparent, divider (or minor-divider), major-divider, line-divider

    @Input()
    title: string = '';

    @Input()
    form: UntypedFormGroup;

    @Input()
    allowClose: boolean = false;

    @Input()
    blockWidth: string = '1'; //1,2,3,4,full,    auto?

    @Input()
    badgeClass: string = ''; //info, success, error

    @Input()
    set badgeText(value: string) {
        if (!value) {
            this._badgeText = '';
            return;
        }
        if (value == '') {
            this._badgeText = '';
            return;
        }
        this._badgeText = value;
        return;
    }

    get badgeText(): string {
        return this._badgeText;
    }

    @Input()
    collapseTitleArea = false;

    @Input()
    showErrorIndicator = true;

    @Input()
    name: string = null;

    @Input()
    allowUxHide: boolean = false;

    @Output()
    onClose = new EventEmitter();

    close() {
        this.onClose.emit();
    }

    get minTitleHeight(): string {
        return (this.title > ' ' && this.panelType != 'line-divider') ||
            this.panelType == 'divider' ||
            this.panelType == 'major-divider' ||
            this.panelType == 'minor-divider'
            ? '28px'
            : this.form != null && this.collapseTitleArea == false
                ? '16px'
                : '0px';
    }

    constructor(private changeDet: ChangeDetectorRef, private app: AppService, private pageOS: PageObjectService) { }

    ngOnInit() {
        if (this.allowUxHide) {
            //initialize hidden value
            let mainComponentConfig = this.pageOS.getSectionUxdMainComponentConfig();
            if (mainComponentConfig && mainComponentConfig[this.name] && mainComponentConfig[this.name].hidden) {
                this.hidden = true;
            }
        }
    }

    public toggleHidden() {
        let mainComponentConfig = this.pageOS.getSectionUxdMainComponentConfig();
        if (this.hidden) {
            this.hidden = false;
            if (mainComponentConfig && mainComponentConfig[this.name]) {
                //remove hidden property
                delete mainComponentConfig[this.name].hidden;
            }
        } else {
            this.hidden = true;
            if (!mainComponentConfig) {
                mainComponentConfig = {};
            }
            if (!mainComponentConfig[this.name]) {
                mainComponentConfig[this.name] = {};
            }
            mainComponentConfig[this.name].hidden = true;
        }
        this.pageOS.updateSectionUxConfigMainComponent(null, mainComponentConfig);
    }

    public get designerMode(): boolean {
        return this.app.DesignerMode && this.allowUxHide;
    }

    hasFormValidationErrors() {
        if (this.form && this.form.invalid && this.form.touched) {
            return true;
            //return (this.hasTouchedControlWithErrors(this.form))
        }
        return false;
    }

    highlightErrors() {
        this.markAsTouched(this.form);
        this.changeDet.detectChanges();
    }

    markAsTouched(group: UntypedFormGroup | UntypedFormArray) {
        Object.keys(group.controls).map((field) => {
            const control = group.get(field);
            if (control instanceof UntypedFormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof UntypedFormGroup) {
                this.markAsTouched(control);
            }
        });
    }

    getStatusClass(value: string): string {
        if (value) {
            switch (value.toString().toUpperCase()) {
                case 'NEW':
                case 'CREATED':
                case 'SUBMITTED':
                case 'IN REVIEW':
                case 'IN PROCESS':
                case 'OPEN':
                    return 'info';
                case 'ACTIVE':
                case 'ACCEPTED':
                    return 'success';
                case 'LATE':
                    return 'error';
                default:
                    return '';
            }
        } else {
            return '';
        }
    }
}
